import React, { Component } from "react";

export default class OutstandingLeaves extends Component {
  render() {
    return (
      <div className="row col-sm-12">
        <div>
          <h3 style={{ margin: "10px 0px 0px 10px" }}>
            Outstanding Leave Applications
          </h3>

          {this.props.children}
        </div>
      </div>
    );
  }
}
